export default {
  "realTimeRebateAdmin.thead.index": "#NO",
  "realTimeRebateAdmin.thead.gameType": "游戏类型",
  "realTimeRebateAdmin.thead.providerId": "游戏厂商",
  "realTimeRebateAdmin.thead.userGroup": "用户分组",
  "realTimeRebateAdmin.thead.vipGroup": "VIP分组",
  "realTimeRebateAdmin.thead.rollover": "流水倍数",
  "realTimeRebateAdmin.thead.rebateConfig": "返现配置",
  "realTimeRebateAdmin.thead.createdAt": "创建时间",
  "realTimeRebateAdmin.thead.updatedAt": "更新新时间",
  "realTimeRebateAdmin.thead.status": "状态",
  "realTimeRebateAdmin.thead.active": "反水开关",
  "realTimeRebateAdmin.thead.mandatorySettlementCycle": "强制结算周期",
  "realTimeRebateAdmin.thead.bonusPayoutStrategy": "派发方式",
  "realTimeRebateAdmin.bonusPayoutStrategy.auto": "自动(系统自动发放)",
  "realTimeRebateAdmin.bonusPayoutStrategy.manual": "人工(运营手工发放)",
  "realTimeRebateAdmin.bonusPayoutStrategy.userCollection": "用户自领",
  "realTimeRebateAdmin.thead.collectionTimeType": "领取时间",
  "realTimeRebateAdmin.thead.theNextDay": "次日领取",
  "realTimeRebateAdmin.thead.realTime": "实时领取",
  "realTimeRebateAdmin.thead.collectionTime": "选择时间",
  "realTimeRebateAdmin.thead.rewardExpirationDays": "过期天数",
  "realTimeRebateAdmin.thead.bindSite": "绑定站点",
  "realTimeRebateAdmin.thead.rebateSetting": "实时反现设置",

  "realTimeRebateAdmin.rebateSetting": "返现设置",
  "realTimeRebateAdmin.add": "新增",
  "realTimeRebateAdmin.edit": "编辑",
  "realTimeRebateAdmin.details": "详情",
  "realTimeRebateAdmin.delete": "删除",
  "realTimeRebateAdmin.thead.action": "操作",
  "realTimeRebateAdmin.showConfig": "查看配置",
};
